import { MenuMappingSectionResource } from 'api'
import { TableColumn } from 'components/Table/Table'
import { Popover } from 'components/Popover/Popover'
import { PopoverTrigger } from 'components/Popover/PopoverTrigger'
import { PopoverContent } from 'components/Popover/PopoverContent'

import { IconButton } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { Link } from 'react-router-dom'
import outline_preview_icon from 'assets/icons/outline-preview-icon.svg'

import * as Styled from './styles'
import { getMenuManagementPreviewURL } from 'utils'

export const getMenuColumns = (
  locationId: string,
  onView: (row: MenuMappingSectionResource) => void,
  onRename: (row: MenuMappingSectionResource) => void,
  onDelete: (row: MenuMappingSectionResource) => void,
  isPrinterClient?: boolean,
): Array<TableColumn<MenuMappingSectionResource>> =>
  !isPrinterClient ? [
    {
    dataIndex: 'preview',
    key: 'preview',
    title: '',
    render: (row) => (
      <Styled.MobilePlatformContainer>
        {row.attributes.title === 'Ubereats' ? 'Uber Eats' : row.attributes.title}
        <Link to={getMenuManagementPreviewURL(locationId, row.id)}>
          <Styled.IconContainer>
            <Styled.Icon src={outline_preview_icon} alt='preview menu icon' iconSize={'24'} data-testid="preview-button" />
          </Styled.IconContainer>
        </Link>
      </Styled.MobilePlatformContainer>
    ),
  },
  ] : [
  {
    dataIndex: 'preview',
    key: 'preview',
    title: '',
    render: (row) => (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }} data-testid="preview-container">
        <Styled.MenuContainer data-testid="menu-title">
          {row.attributes.title === 'Ubereats' ? 'Uber Eats' : row.attributes.title}
        </Styled.MenuContainer>
        <Popover placement="left">
          <PopoverTrigger asChild>
            <IconButton
              sx={{ borderRadius: '4px', width: '28px', height: '28px' }}
              size="small"
              aria-label="menu actions"
              data-testid="menu-actions-button"
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>
          </PopoverTrigger>
          <PopoverContent>
            <Styled.PopoverMenu data-testid="menu-actions">
              <Styled.PopoverMenuItem onClick={() => onView(row)} data-testid="view-button">View Menu</Styled.PopoverMenuItem>
              <Styled.PopoverMenuItem onClick={() => onRename(row)} data-testid="rename-button">Rename</Styled.PopoverMenuItem>
              <Styled.PopoverMenuItem danger onClick={() => onDelete(row)} data-testid="delete-button">Delete</Styled.PopoverMenuItem>
            </Styled.PopoverMenu>
          </PopoverContent>
        </Popover>
      </div>
    ),
  },
]